module.exports = __webpack_public_path__ + "img/87.8d0ce9ed.jpg";